export class RequestUser {
  /** Firebase User ID */
  readonly id: string;
  readonly name: string;
  readonly email: string | null;
  readonly phone: string | null;
}
